// Datos ficticios de ejemplo — plantilla "Atelier" (segunda boda).
// Incluye portadaVideo: clip ambiental de YouTube con poster de respaldo.

export const datosEjemplo = {
  tipoEvento: "boda",
  plantillaId: "boda-atelier",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "La cuenta regresiva", titulo: "Nos vemos en", textoFinalizado: "¡Llegó el gran día!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "El gran día", titulo: "Ceremonia y celebración" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Reservá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Nosotros", titulo: "Nuestra historia en fotos" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El programa", titulo: "Itinerario del día" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Nuestras familias", titulo: "Quienes nos acompañan" },
    { id: "video", visible: true, orden: 7, etiqueta: "Nuestra historia", titulo: "Mirá nuestro video" },
    { id: "musica", visible: true, orden: 8, etiqueta: "La banda sonora", titulo: "Nuestras canciones" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Confirmación", titulo: "Confirmá tu asistencia" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Datos útiles", titulo: "Información adicional" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participá", titulo: "Dejá tu huella" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  pareja: {
    nombre1: "Ana",
    nombre2: "Luis",
    fraseIntroductoria: "Nos casamos",
    mensajePortada:
      "Con la bendición de nuestras familias, queremos invitarte a celebrar nuestro matrimonio.",
    mensajeCierre:
      "Nada de esto tendría sentido sin ustedes. Gracias por acompañarnos siempre.",
  },

  evento: {
    fechaISO: "2027-02-27T18:00:00-03:00",
    fechaLegible: "Sábado 27 de febrero de 2027",
    fechaCorta: "27 · 02 · 2027",
    ciudad: "Asunción, Paraguay",
  },

  // Clip ambiental de YouTube para la portada. El poster se muestra mientras
  // carga, si el video no está disponible o si el usuario prefiere menos movimiento.
  portadaVideo: {
    urlYoutube: "https://www.youtube.com/watch?v=LXb3EKWsInQ",
    poster:
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Las manos de Ana y Luis con las alianzas",
      },
      {
        src: "https://images.unsplash.com/photo-1606800052052-a08af7148866?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Ana y Luis abrazados",
      },
      {
        src: "https://images.unsplash.com/photo-1520854221256-17451cc331bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Ana con el ramo de novia",
      },
      {
        src: "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Mesa de la recepción decorada",
      },
    ],
  },

  eventos: [
    {
      id: "ceremonia",
      etiqueta: "Ceremonia religiosa",
      lugar: "Catedral Metropolitana",
      direccion: "Plaza de la Independencia, Asunción",
      horario: "18:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Catedral+Metropolitana+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
    {
      id: "celebracion",
      etiqueta: "Recepción y cena",
      lugar: "Quinta La Escondida",
      direccion: "Acceso Sur, km 22, Capiatá",
      horario: "20:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Capiat%C3%A1+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Boda Ana & Luis",
    descripcion: "Ceremonia 18:00 h en Catedral Metropolitana y recepción 20:00 h en Quinta La Escondida.",
    texto: "Sábado 27 de febrero de 2027 · Asunción, Paraguay. Guardá la fecha.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-02-27T18:00:00-03:00",
    finISO: "2027-02-28T02:00:00-03:00",
    ubicacion: "Catedral Metropolitana, Asunción, Paraguay",
  },

  itinerario: [
    { hora: "18:00", titulo: "Ceremonia", descripcion: "Catedral Metropolitana de Asunción.", icono: "iglesia" },
    { hora: "19:30", titulo: "Recepción", descripcion: "Brindis de bienvenida en la quinta.", icono: "copas" },
    { hora: "20:30", titulo: "Cena", descripcion: "Cena de tres pasos al aire libre.", icono: "cena" },
    { hora: "22:00", titulo: "Vals y baile", descripcion: "Abrimos la pista.", icono: "musica" },
    { hora: "00:30", titulo: "Cierre", descripcion: "Despedida con luces de bengala.", icono: "brillo" },
  ],

  menciones: [
    {
      nombre: "Elena Fernández",
      rol: "Madre de la novia",
      foto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Ricardo Fernández",
      rol: "Padre de la novia",
      foto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Carmen Ruiz",
      rol: "Madre del novio",
      foto: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Pablo Ruiz",
      rol: "Padre del novio",
      foto: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play cuando quieras. La música nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Nos encantaría contar con tu presencia. Confirmá tu asistencia y la de tus acompañantes.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 27 de enero de 2027",
  },

  enlaces: [
    { texto: "Dress code: formal", url: "https://www.pinterest.com" },
    { texto: "#AnaYLuis2027", url: "https://www.instagram.com" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejanos tus palabras para este día.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Compartí tus fotos de la boda.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
